import React, { useEffect, useState } from 'react'
import { Col, Row, Image, Table, Card } from 'react-bootstrap'
import imgSKY from '../../../images/SKY.png'
import imgMettheir from '../../../images/MT.jpg'
import imgAstro from '../../../images/ASTRO.png'
import imgProInside from '../../../images/ProInside.png'
import { useSearchParams } from 'react-router-dom'
import { getContractDetailAPI } from '../../../services/contract'
import { useSelector } from 'react-redux'
import ContractCompensitionNav from './contract-nav-compensition'
import moment from 'moment'
import { BsApp } from 'react-icons/bs'
import Error_500 from '../../error/error-500'

export default function CompensitionPreview() {
  const [data, setData] = useState([])
  // const orgId = useSelector((state) => state.roleReducer.role)
  let [searchParams, setSearchParams] = useSearchParams()
  const phones = searchParams.get('phone')
  const orgId = searchParams.get('orgId')
  const phone = phones ? phones.replace(/\s/g, '') : ''
  const idCard = searchParams.get('idCard')
  const [isConfirm1, setIsConfirm1] = useState()
  const [isConfirm2, setIsConfirm2] = useState()
  const [isConfirm3, setIsConfirm3] = useState()
  const [isConfirm4, setIsConfirm4] = useState()
  const [signaturePD, setSignaturePD] = useState([])
  const [isCheck1, setIsCheck1] = useState()
  const [isLoading, setIsLoading] = useState(true)
  const [signatureCEO, setSignatureCEO] = useState([])
  const [signatureTO, setSignatureTO] = useState([])
  const [signatureEMP, setSignatureEMP] = useState([])
  const [signatureVP, setSignatureVP] = useState([])
  const [signatureC, setSignatureC] = useState([])
  const [signatureVPPD, setSignatureVPPD] = useState([])

  useEffect(() => {
    getContractDetail()
    moment.locale('th')
  }, [orgId, idCard, phone])

  const getContractDetail = async () => {
    try {
      setIsLoading(true)

      const param = { orgId, idCard, phone }
      const result = await getContractDetailAPI(param)
      setIsLoading(false)

      if (!result) return
      if (result.status) {
        setData(result.result)
        setIsConfirm1(result.result.signatures_pd[0].pd1.is_confirm)
        setIsConfirm2(result.result.signatures_pd[1].pd2.is_confirm)
        setIsConfirm3(result.result.signatures_pd[2].pd3.is_confirm)
        setIsConfirm4(result.result.signatures_pd[3].pd4.is_confirm)
        setSignaturePD(result.result.signatures_pd[0].pd1)
        setIsCheck1(result.result.signatures_pd[0].pd1.is_confirm)

        setSignatureCEO(result.result.signatures[0].ceo)
        setSignatureVP(result.result.signatures[2].vp)
        setSignatureTO(result.result.signatures[4].report_to)
        setSignatureEMP(result.result.signatures[5].employee)
        setSignatureC(result.result.signatures[1].c_level)
        setSignatureVPPD(result.result.signatures[3].vp_pd)
      }
    } catch (error) {
      Error_500(error)
    }
  }

  return (
    <>
      {isLoading && <div className="preloader"></div>}

      <ContractCompensitionNav
        getContractDetail={getContractDetail}
        data={data}
        isCheck1={isCheck1}
        signatureCEO={signatureCEO}
        signatureTO={signatureTO}
        signatureEMP={signatureEMP}
        signatureVP={signatureVP}
        signatureC={signatureC}
        signatureVPPD={signatureVPPD}
      />
      <Row>
        <Col xl={12}>
          <Card.Body
            className="p-2 m-2 fw-normal"
            style={{
              lineHeight: 2
            }}
          >
            <div className="d-flex justify-content-center">
              {data?.org_id === 1 ? (
                <Image
                  className="mt-3"
                  style={{
                    width: 115,
                    height: 60
                  }}
                  src={imgSKY}
                />
              ) : data?.org_id === 2 ? (
                <Image
                  className="mt-2"
                  style={{
                    width: 120,
                    height: 100
                  }}
                  src={imgMettheir}
                />
              ) : data?.org_id === 3 ? (
                <Image
                  className="mb-1"
                  style={{
                    width: 100,
                    height: 90
                  }}
                  src={imgAstro}
                />
              ) : data?.org_id === 5 ? (
                <Image
                  className="mt-3"
                  style={{
                    width: 140,
                    height: 70
                  }}
                  src={imgProInside}
                />
              ) : null}
            </div>
            <h5
              className="text-center mb-1 mt-4"
              style={{
                fontSize: 20
              }}
            >
              {data?.org_th}
            </h5>
            <p className="text-center mb-3">แจ้งค่าตอบแทนพนักงาน</p>
            <p className="fw-light small mb-0">เรื่อง แจ้งค่าตอบแทนพนักงาน</p>
            <p className="fw-light small mt-0">เรียน ประธานเจ้าหน้าที่บริหาร</p>
            <p className="fw-light small ">
              &nbsp; &nbsp; &nbsp; &nbsp;ข้าพเจ้าขอแจ้งค่าตอบแทนของพนักงาน ชื่อ
              {data?.title_th || '-'}
              {data?.name_th || '-'} {data?.surname_th || '-'}{' '}
              {data?.position_th || '-'} Level {data?.level_id || '-'}{' '}
              {data?.division_th || '-'} {data?.faction_th || '-'}{' '}
              {data?.department_th || '-'} ในกรณีจัดจ้างพนักงานใหม่
              โดยกำหนดเริ่มงานในวันที่{' '}
              {moment(data?.start_date).add(543, 'year').format('D MMMM YYYY')}
            </p>
            <p className="fw-light small mt-0">
              &nbsp; &nbsp; &nbsp; &nbsp;โดยมีรายละเอียดของค่าตอบแทนเป็นดังนี้
            </p>
            <Table className="col-6 border">
              <thead>
                <tr className="fw-light font-title-table text-center ">
                  <th>
                    <p
                      className="fw-light small "
                      style={{
                        marginTop: -40
                      }}
                    >
                      ระหว่างทดลองงาน: ผ่านทดลองงาน
                    </p>
                    <p
                      className="fw-light small"
                      style={{
                        marginTop: 50
                      }}
                    >
                      เงินเดือน ...............................................
                      บาท/เดือน
                    </p>
                  </th>
                  <th>
                    <p className="fw-light small mt-3">
                      <BsApp /> ไม่มีการปรับหลังจากผ่านทดลองงาน
                    </p>
                    <p className="fw-light small mt-0 ">
                      <BsApp /> ปรับเพิ่มทันทีเมื่อผ่านทดลองงาน
                    </p>

                    <p className="fw-light small mt-0">
                      เงินเดือน
                      ........................................-........................................บาท/เดือน
                    </p>
                  </th>
                </tr>
              </thead>
            </Table>{' '}
            {isConfirm1 === 1 &&
            isConfirm2 === 1 &&
            isConfirm3 === 1 &&
            isConfirm4 === 1 ? (
              <div
                className="border-2 p-5 mt-5 card d-flex justify-content-center align-items-center"
                style={{
                  borderRadius: '5px',
                  border: 'dotted',
                  maxHeight: '300px'
                }}
              >
                {signaturePD && (
                  <div className="col-6">
                    <p className="fw-light text-center small mt-4 ">
                      <span className="m-0 p-0 d-flex justify-content-center">
                        <Image
                          src={signaturePD?.url || null}
                          style={{
                            width: '150px',
                            marginBottom: -25
                          }}
                        ></Image>
                      </span>
                      ลงชื่อ........................................................................
                      ผู้ดำเนินการ
                    </p>
                    <p className="fw-light text-center small mt-0">
                      ( {signaturePD?.title_th || '-'}
                      {signaturePD?.name_th || '-'}{' '}
                      {signaturePD?.surname_th || '-'} )
                    </p>
                    <p className="fw-light text-center small mt-0 ">
                      {signaturePD?.position_th || '-'}
                    </p>
                    <p className="fw-light text-center small mt-0">
                      วันที่{' '}
                      {signaturePD.confirm_date_pd
                        ? moment(signaturePD.confirm_date_pd)
                            .add(543, 'year')
                            .format('D MMMM YYYY HH:mm')
                        : '-'}
                    </p>
                  </div>
                )}
              </div>
            ) : (
              <></>
            )}
          </Card.Body>
        </Col>
      </Row>
    </>
  )
}
